import { TodoTypeDto } from '@act/shared/data-transfer-objects';
import { Order } from 'react-components/member-index/sortable-table-headers';
import { TodoDtoWithMember } from '../docket-types';
import { FOLLOW_UP_HEADERS } from '../hooks/useFollowUpEventsData';

export function getFollowUpEventComparator(
  order: Order,
  orderBy: FOLLOW_UP_HEADERS
) {
  if (!orderBy) {
    return (a, b) => followUpItemComparator(a, b, 'createdAt');
  }
  return order === 'desc'
    ? (a, b) => followUpItemComparator(a, b, orderBy)
    : (a, b) => -followUpItemComparator(a, b, orderBy);
}

function followUpItemComparator(
  a: TodoDtoWithMember,
  b: TodoDtoWithMember,
  orderBy: FOLLOW_UP_HEADERS
): number {
  if (orderBy === 'id') {
    return orderByMemberNameComparator(a, b);
  }

  if (orderBy === 'type') {
    return orderByEventTypeComparator(a, b);
  }

  if (orderBy === 'requiredAction') {
    return orderByRequiredActionComparator(a, b);
  }

  if (orderBy === 'createdAt') {
    return orderByCreatedAtComparator(a, b);
  }
}

function orderByMemberNameComparator(
  a: TodoDtoWithMember,
  b: TodoDtoWithMember
) {
  return b.member.name.localeCompare(a.member.name);
}

function orderByEventTypeComparator(
  a: TodoDtoWithMember,
  b: TodoDtoWithMember
) {
  const order: TodoTypeDto[] = [
    TodoTypeDto.CALL_BACK,
    TodoTypeDto.TEXT_BACK,
    TodoTypeDto.INCOMPLETE_CALL,
    TodoTypeDto.INCOMPLETE_NOTE_CALL,
    TodoTypeDto.INCOMPLETE_VISIT,
    TodoTypeDto.INCOMPLETE_NOTE_VISIT,
    TodoTypeDto.CALL_AUDIT,
  ];

  const directionOrder = [true, false];

  const difference = order.indexOf(b.type) - order.indexOf(a.type);
  let callDifference = undefined;

  if (
    difference === 0 &&
    [TodoTypeDto.INCOMPLETE_CALL, TodoTypeDto.INCOMPLETE_NOTE_CALL].includes(
      a.type
    )
  ) {
    callDifference =
      directionOrder.indexOf(b.call.incoming) -
      directionOrder.indexOf(a.call.incoming);

    if (callDifference === 0) {
      return orderByCreatedAtComparator(a, b);
    }

    return callDifference;
  }

  return difference;
}

function orderByRequiredActionComparator(
  a: TodoDtoWithMember,
  b: TodoDtoWithMember
) {
  const order: TodoTypeDto[] = [
    TodoTypeDto.CALL_BACK,
    TodoTypeDto.TEXT_BACK,
    TodoTypeDto.INCOMPLETE_CALL,
    TodoTypeDto.INCOMPLETE_NOTE_CALL,
    TodoTypeDto.INCOMPLETE_NOTE_VISIT,
    TodoTypeDto.INCOMPLETE_VISIT,
    TodoTypeDto.CALL_AUDIT,
  ];

  return order.indexOf(b.type) - order.indexOf(a.type);
}

function orderByCreatedAtComparator(
  a: TodoDtoWithMember,
  b: TodoDtoWithMember
) {
  return b.createdAt - a.createdAt;
}
